module.exports = "<div [hidden]=\"!isDelayedRunning\" class=\"spinner\">  \r\n    <div class=\"double-bounce1\"></div>\r\n    <div class=\"double-bounce2\"></div>\r\n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/spinner/spinner.component.html
// module id = ./src/app/components/spinner/spinner.component.html
// module chunks = main